import {
  AgingReportBalanceStatusData,
  AgingReportBalanceStatusType,
} from "../util/getAgingReportStatus";
import { titlecase } from "stringcase";

const STATUS_ICON_CLASSES: Record<string, string> = {
  paid: "fa-solid fa-dollar-sign",
  changed: "fa-solid fa-question",
  outstanding: "fa-solid fa-money-check-dollar",
  archived: "fa-solid fa-archive",
  "deadline-passed": "fa-solid fa-triangle-exclamation",
  "extended-deadline-passed": "fa-solid fa-triangle-exclamation",
  "message-provided": "fa-solid fa-comment",
  "response-provided": "fa-solid fa-comments",
};

const HTML_ESCAPES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

// Tooltip html is injected unsanitized and messages are user-authored
const escapeHtml = (text: string) => text.replace(/[&<>"']/g, (char) => HTML_ESCAPES[char]);

export const StatusIcon = ({
  statusType,
  statusData,
}: {
  statusType: AgingReportBalanceStatusType;
  statusData?: AgingReportBalanceStatusData;
}) => {
  const isMessageType =
    AgingReportBalanceStatusType.MessageProvided === statusType;
  const messages = isMessageType ? statusData?.messages : undefined;
  const tooltip = messages?.length
    ? { "data-tooltip-html": messages.map(escapeHtml).join("<br/>") }
    : { "data-tooltip-content": titlecase(statusType) };

  return (
    <>
      <i
        className={`${STATUS_ICON_CLASSES[statusType]} tooltip-anchor`}
        data-tooltip-place="bottom"
        {...tooltip}
      ></i>
      {isMessageType && <span className="badge">{statusData?.count}</span>}
    </>
  );
};
